module.exports = __webpack_public_path__ + "static/media/ic_template_2.7dfef669.png";